module.exports = __webpack_public_path__ + "img/gaotao.315940bb.png";